// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Analytics24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Analytics24: FC<Analytics24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M5 21c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 19V3h2v16h16v2H5Zm1-3V9h4v9H6Zm5 0V4h4v14h-4Zm5 0v-5h4v5h-4Z" />
        </svg>
    );
};

export default Analytics24;
